/**
 * Odemly photo uploader -> cart-page redirect.
 * Odemly shows #pf-added only after /cart/add.js succeeds.
 * This script leaves Odemly's upload/add request untouched and redirects both
 * mobile and desktop customers to the cart page after that success signal.
 */
(() => {
  'use strict';

  let redirecting = false;

  const isVisible = (element) => {
    if (!element) return false;
    const styles = window.getComputedStyle(element);
    return styles.display !== 'none' && styles.visibility !== 'hidden';
  };

  const cartUrl = () => {
    if (window.routes && window.routes.cart_url) return window.routes.cart_url;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return `${root}cart`;
  };

  const redirectToCart = (successBox) => {
    if (redirecting) return;
    redirecting = true;

    // Hide Odemly's intermediate confirmation during navigation.
    successBox.style.setProperty('display', 'none', 'important');
    successBox.setAttribute('aria-hidden', 'true');

    window.location.assign(cartUrl());
  };

  const checkSuccessBox = (node) => {
    if (redirecting || !(node instanceof Element)) return;

    const successBox = node.matches('#pf-added')
      ? node
      : node.querySelector('#pf-added');

    if (successBox && isVisible(successBox)) redirectToCart(successBox);
  };

  const start = () => {
    const existing = document.getElementById('pf-added');
    if (existing) checkSuccessBox(existing);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') checkSuccessBox(mutation.target);
        mutation.addedNodes.forEach(checkSuccessBox);
      });
    }).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden']
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
